import AuthModule from "@/store/modules/auth";
import { computed } from "vue";

export const isUserLoggedIn = computed(() => {
  return AuthModule.getToken;
});
